<script setup lang="ts">

import { FiltersBar } from '@shared/ui/filters'
import { BtnPrimary } from '@shared/ui/buttons'
import { AppMultiSelect, AppSelect } from '@shared/ui/selects'

import { useFiltersDisciplineBalances } from '../model/filters-discipline-balances.hook'

defineOptions({
  name: 'FiltersDisciplineBalances',
})

const {
  refReasons,
  refResponsible,
  reasonOptions,
  responsibleOptions,
  isLoading,
  canManageBalances,
  search,
  clearFilters,
  openEditBalance,
} = useFiltersDisciplineBalances()
</script>

<template>
  <FiltersBar
    class="filters-discipline-balances"
    :loading="isLoading"
    @click:submit="search"
    @click:clear="clearFilters"
  >
    <template #fields>
      <AppMultiSelect
        v-model="refReasons"
        class="filters-discipline-balances__reason"
        :options="reasonOptions"
        label="Reason"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <AppSelect
        v-model="refResponsible"
        class="filters-discipline-balances__responsible"
        :options="responsibleOptions"
        label="Responsible"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
    </template>

    <template #end>
      <BtnPrimary
        v-if="canManageBalances"
        text="Edit balance"
        color="emerald"
        @click="openEditBalance"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersDisciplineBalances.scss" />
